// Tickable Mail: campaigns, contacts (Visitors) and segments (en)
export default {
  "mail_contacts_growth_question": "Who can you send news e-mails to?",
  "mail_segment_narrow": "Only to certain people",
  // Segment
  "mail_segment_events": "Came to",
  "mail_segment_events_any": "All events",
  "mail_segment_ticket_types": "With ticket type",
  "mail_segment_ticket_types_any": "All ticket types",
  "mail_segment_ticket_types_pick_event": "Pick an event first",
  "mail_segment_period": "Visited between",
  "mail_segment_period_any": "Any time",
  "mail_segment_period_help": "The date of the visit, so of the timeslot.",
  "mail_segment_exclude_events": "No ticket yet for",
  "mail_segment_exclude_events_none": "Any",
  "mail_segment_exclude_events_help": "For example: came last year (above), has no ticket for this year yet (here).",
  "mail_segment_min_orders": "Bought at least",
  "mail_segment_min_orders_any": "Any",
  "mail_segment_min_orders_help": "Orders with your organization, across all activities. For your regulars.",
  "mail_segment_presets": "Quick pick:",
  "mail_segment_preset_everyone": "Everyone",
  "mail_segment_preset_regulars": "Regulars (3+)",
  "mail_segment_preset_lapsed": "Last year, not yet this year",
  "mail_segment_preset_lapsed_help": "Pick last year's activity under \"Came to\", and this year's under \"No ticket yet for\".",
  "mail_segment_preset_no_shows": "Bought, did not come",
  "mail_segment_attendance": "Attendance",
  "mail_segment_attendance_any": "Any",
  "mail_segment_attendance_came": "Came (scanned)",
  "mail_segment_attendance_no_show": "Did not come",
  "mail_segment_tags": "Tags",
  "mail_segment_tags_any": "All tags",
  "mail_segment_tags_none": "No tags yet",
  "mail_segment_tags_mode_any": "Any of these",
  "mail_segment_tags_mode_all": "All of them",
  "mail_segment_languages": "Language",
  "mail_segment_languages_any": "All languages",
  "mail_segment_count_nobody": "Nobody matches these filters.",
  "mail_segment_count_reachable": "Nobody with consent | 1 recipient | {n} recipients",
  "mail_segment_count_skipped": "{n} without consent left out",

  // Campaigns list
  "mail_campaign_intro": "Your newsletters and your messages to visitors. You start a message to visitors on the page of your activity.",
  "mail_campaign_new": "New campaign",
  "mail_campaign_default_name": "Campaign {date}",
  "mail_campaign_create_failed": "Couldn't create the campaign",
  "mail_campaign_load_failed": "Couldn't load campaigns",
  "mail_campaign_quota_sent": "{sent} of {limit} newsletters this month",
  "mail_campaign_quota_contacts": "{contacts} of {limit} contacts with consent",
  "mail_campaign_quota_contacts_over": "You have more than {limit} contacts with consent, so you can't send campaigns right now. Get in touch and we'll sort it out together.",
  "mail_campaign_quota_month_full": "You've used all your newsletters for this month. You can send again next month.",
  "mail_campaign_empty_title": "No campaigns yet",
  "mail_campaign_empty": "Create your first campaign: choose who gets it, pick a mail and send yourself a test first.",
  "mail_campaign_empty_no_contacts": "Nobody has given consent yet, so there's nobody to mail.",
  "mail_campaign_empty_contacts_link": "How your list grows",
  "mail_campaign_name": "Name",
  "mail_campaign_recipients": "Recipients",
  "mail_campaign_edited": "edited {when}",
  "mail_campaign_status_draft": "Draft",
  "mail_campaign_status_scheduled": "Scheduled",
  "mail_campaign_status_sending": "Sending",
  "mail_campaign_status_sent": "Sent",
  "mail_campaign_status_cancelled": "Cancelled",

  // Wizard
  "mail_campaign_not_found": "This mail doesn't exist (anymore).",
  "mail_campaign_saving": "Saving…",
  "mail_campaign_saved": "Saved",
  "mail_campaign_save_failed": "Couldn't save",
  "mail_campaign_step_recipients": "Recipients",
  "mail_campaign_step_content": "Content",
  "mail_campaign_step_send": "Send",
  "mail_campaign_recipients_intro": "Without filters it goes to everyone with consent. Anyone who didn't give consent never gets it.",
  "mail_campaign_pick_mail": "Which mail?",
  "mail_campaign_no_templates": "You don't have a newsletter yet. Start from one of the examples below.",
  "mail_campaign_new_mail_from": "New mail based on:",
  "mail_campaign_template_failed": "Couldn't create the mail",
  "mail_campaign_preview": "This is how it looks",
  "mail_campaign_preview_language": "Preview language",
  "mail_campaign_preview_failed": "Couldn't load the preview. Try again in a moment.",
  "mail_campaign_edit_mail": "Edit",
  "mail_campaign_mail": "Mail",
  "mail_campaign_no_send_right": "You can prepare this campaign, but only someone with the right to send campaigns can send it.",
  "mail_campaign_postal_missing": "Every newsletter has to include your postal address; it's required by law. You haven't filled it in yet.",
  "mail_campaign_postal_link": "Add postal address",
  "mail_campaign_summary": "What's going to happen",
  "mail_campaign_summary_line": "Nobody gets ‘{subject}’. | 1 person gets ‘{subject}’. | {n} people get ‘{subject}’.",
  "mail_campaign_summary_no_recipients": "Nobody with consent matches your filters yet.",
  "mail_campaign_summary_no_mail": "Pick a mail under Content first.",
  "mail_campaign_quota_after": "After this you'll have used {used} of {limit} newsletters this month.",
  "mail_campaign_quota_would_exceed": "That doesn't fit: you have {left} of {limit} newsletters left this month. Make your group smaller or wait until next month.",
  "mail_campaign_test_title": "A test mail first",
  "mail_campaign_test_intro": "You get it yourself first, so you see how it arrives. Change something afterwards? Then send another test.",
  "mail_campaign_test_send": "Send test mail to me",
  "mail_campaign_test_again": "Send another test",
  "mail_campaign_test_sent": "Test sent to {to}",
  "mail_campaign_test_failed": "Couldn't send the test mail",
  "mail_campaign_when_title": "When?",
  "mail_campaign_mode_now": "Now",
  "mail_campaign_mode_later": "Later",
  "mail_campaign_schedule_at": "Send on",
  "mail_campaign_send_now": "Send now",
  "mail_campaign_schedule": "Schedule",
  "mail_campaign_send_needs_test": "Send a test mail first.",
  "mail_campaign_confirm_now_title": "Send now?",
  "mail_campaign_confirm_now": "Nobody will get anything. | 1 person gets this mail right away. Once it's sent, you can't undo it. | {n} people get this mail right away. Once it's sent, you can't undo it.",
  "mail_campaign_confirm_later_title": "Schedule?",
  "mail_campaign_confirm_later": "Nobody will get anything. | 1 person gets this mail on {when}. You can cancel until then. | {n} people get this mail on {when}. You can cancel until then.",
  "mail_campaign_recipients_count": "No recipients | 1 recipient | {n} recipients",
  "mail_campaign_error_not_allowed": "You don't have the right to send campaigns.",
  "mail_campaign_error_mail_campaign_not_draft": "This campaign has already been scheduled or sent.",
  "mail_campaign_error_mail_not_enabled": "Newsletters only work once you've switched on the new mails.",
  "mail_campaign_error_mail_campaign_without_template": "Pick a mail under Content first.",
  "mail_campaign_error_mail_postal_address_missing": "Every newsletter has to include your postal address, and you haven't filled it in yet.",
  "mail_campaign_error_mail_contact_limit": "You have more people with consent than you can mail for free. Ask for a higher limit at the top.",
  "mail_campaign_error_mail_campaign_no_recipients": "Nobody with consent matches your filters.",
  "mail_campaign_error_mail_monthly_limit": "This would take you over your newsletter limit for this month. Make your group smaller or wait until next month.",
  "mail_campaign_error_unknown": "That didn't work. Try again, and if it still doesn't work, let us know.",
  "mail_campaign_error_contacts_link": "Go to your contacts",
  "mail_campaign_error_already_sending": "Mails have already gone out, so it can't be cancelled anymore.",

  // After scheduling
  "mail_campaign_scheduled_for": "Scheduled for",
  "mail_campaign_sent_at": "Sent on",
  "mail_campaign_progress": "Progress",
  "mail_campaign_progress_line": "{done} of {total} handled",
  "mail_campaign_cancel": "Cancel campaign",
  "mail_campaign_cancel_help": "Possible as long as nothing has been sent. The campaign turns back into a draft.",
  "mail_campaign_cancel_title": "Cancel campaign?",
  "mail_campaign_cancel_confirm": "Nothing goes out and the campaign turns back into a draft, so you can change it.",
  "mail_campaign_cancel_failed": "Couldn't cancel",

  // Contacts (Visitors)
  "mail_contacts_stats_total": "No contacts yet | 1 contact | {n} contacts",
  "mail_contacts_stats_consent": "{n} with consent",
  "mail_contacts_stats_regulars": "1 regular | {n} regulars",
  "mail_contacts_stats_unsubscribed": "{n} unsubscribed",
  "mail_contacts_stats_broken": "{n} unreachable",
  "mail_contacts_growth": "You may only send newsletters to people who chose to get them. Your list grows when buyers tick the box in your shop, when people sign up through your form, or when you import an existing list. Buyers from before the box only get mail about their own order.",
  "mail_contacts_growth_link": "Set up the box in your shop",
  "mail_contacts_import": "Import",
  "mail_contacts_search": "Search by name or e-mail address",
  "mail_contacts_filter_consent_yes": "With consent",
  "mail_contacts_filter_consent_no": "Without consent",
  "mail_contacts_filter_tags": "Activity or tag",
  "mail_contacts_filter_orders": "Orders",
  "mail_contacts_filter_orders_returning": "2 times or more",
  "mail_contacts_filter_orders_once": "Ordered once",
  "mail_contacts_filter_source": "Source",
  "mail_contacts_load_failed": "Couldn't load contacts",
  "mail_contacts_empty_title": "No contacts yet",
  "mail_contacts_empty": "As soon as someone buys a ticket or signs up, they show up here. Already have a list in Mailchimp, Brevo or Laposta? Import it and carry on right away.",
  "mail_contacts_empty_filtered": "Nobody found with these filters.",
  "mail_contacts_contact": "Contact",
  "mail_contacts_consent": "Consent",
  "mail_contacts_consent_none": "None",
  "mail_contacts_consent_given": "Given on {date}, {source}.",
  "mail_contacts_consent_none_detail": "No consent for newsletters. This person only gets mail about their own order.",
  "mail_contacts_source_checkout": "through the box in the shop",
  "mail_contacts_source_import": "through an import",
  "mail_contacts_source_signup_form": "through the signup form",
  "mail_contacts_source_waitlist": "through the waitlist",
  "mail_contacts_source_unknown": "source unknown",
  "mail_contacts_tags": "Tags",
  "mail_contacts_tag_add": "Add",
  "mail_contacts_tag_add_placeholder": "New tag",
  "mail_contacts_tag_remove": "Remove tag {tag}",
  "mail_contacts_last_order": "Last order",
  "mail_contacts_with_you": "With you",
  "mail_contacts_orders_n": "Ordered {n}×",
  "mail_contacts_orders_none": "No orders yet",
  "mail_contacts_activities": "Activities and tags",
  "mail_contacts_event_next": "{title}, coming on {date}",
  "mail_contacts_more": "+{n}",
  "mail_contacts_newsletter_yes": "Yes",
  "mail_contacts_newsletter_no": "No",
  "mail_contacts_tier_regular": "Regular",
  "mail_contacts_tier_regular_title": "Ordered from you {n} times or more",
  "mail_contacts_tier_superfan": "Superfan",
  "mail_contacts_tier_superfan_title": "Ordered from you {n} times or more",
  "mail_contacts_status_unsubscribed": "Unsubscribed",
  "mail_contacts_status_bounced": "Not working",
  "mail_contacts_status_complained": "Marked as spam",
  "mail_contacts_status_unsubscribed_on": "Unsubscribed on {date}",
  "mail_contacts_status_bounced_on": "This address doesn't work (since {date})",
  "mail_contacts_status_complained_on": "Marked a mail as spam on {date}",
  "mail_contacts_save_failed": "Couldn't save",
  "mail_contacts_unsubscribe": "Unsubscribe",
  "mail_contacts_unsubscribe_confirm": "{email} won't get newsletters anymore. You can't undo this yourself: only the person can give consent again.",
  "mail_contacts_delete_help": "For when someone asks you to delete their data (GDPR).",
  "mail_contacts_delete_title": "Delete contact?",
  "mail_contacts_delete_confirm": "{email} disappears from your contacts, with tags and consent. Orders stay as they are. If this person buys again later, they come back on the list.",
  "mail_contacts_delete_failed": "Couldn't delete",

  // Import
  "mail_contacts_import_title": "Import contacts",
  "mail_contacts_import_intro": "Coming from Mailchimp, Brevo, Laposta or another tool? Export your list there as CSV or Excel and upload it here. Then tell us which column is which.",
  "mail_contacts_import_choose": "Choose a file",
  "mail_contacts_import_formats": "CSV or Excel (.xlsx)",
  "mail_contacts_import_empty": "This file is empty.",
  "mail_contacts_import_parse_error": "We couldn't read this file. Is it a CSV or .xlsx?",
  "mail_contacts_import_file_rows": "{file}: {n} rows. These are the first:",
  "mail_contacts_import_field_email": "E-mail address",
  "mail_contacts_import_field_name": "Name or first name",
  "mail_contacts_import_field_last_name": "Last name",
  "mail_contacts_import_field_language": "Language",
  "mail_contacts_import_field_tags": "Tags",
  "mail_contacts_import_field_status": "Status",
  "mail_contacts_import_pick_column": "Pick a column",
  "mail_contacts_import_not_in_file": "Not in this file",
  "mail_contacts_import_status_values": "Which statuses mean unsubscribed?",
  "mail_contacts_import_status_help": "People who unsubscribed in your old tool, or whose address didn't work (cleaned), come in as unsubscribed and won't get newsletters.",
  "mail_contacts_import_status_empty": "(empty)",
  "mail_contacts_import_found": "{n} contacts",
  "mail_contacts_import_found_unsub": "{n} unsubscribed",
  "mail_contacts_import_found_invalid": "{n} without a valid e-mail address, we'll skip those",
  "mail_contacts_import_found_duplicates": "{n} duplicates, merged",
  "mail_contacts_import_tags": "Tags for this import",
  "mail_contacts_import_tags_placeholder": "Type a tag and press Enter",
  "mail_contacts_import_tags_help": "Everyone in this file gets these tags. Handy to find them later or mail them separately.",
  "mail_contacts_import_statement": "How did these people give consent?",
  "mail_contacts_import_statement_why": "You may only mail people who chose to get it. We keep what you write here as proof, for when someone asks why they get mail from you.",
  "mail_contacts_import_statement_placeholder": "For example: signed up for our newsletter through the form on our website, kept in Mailchimp since 2021.",
  "mail_contacts_import_confirm": "These people have given consent to receive mail from us.",
  "mail_contacts_import_over_limit": "After this import you may have {n} contacts with consent. On the free plan you can send campaigns up to {limit} contacts; above that, sending stops until your list is smaller or you have a bigger plan.",
  "mail_contacts_import_run": "Import {n} contacts",
  "mail_contacts_import_running": "Importing. Please keep this window open.",
  "mail_contacts_import_done": "Done!",
  "mail_contacts_import_partial": "The import stopped halfway",
  "mail_contacts_import_failed": "Import failed",
  "mail_contacts_import_failed_detail": "What's listed above did come in. Error: {message}",
  "mail_contacts_import_count_added": "New",
  "mail_contacts_import_count_updated": "Updated",
  "mail_contacts_import_count_unchanged": "Already known, nothing changed",
  "mail_contacts_import_count_unsubscribed": "As unsubscribed",
  "mail_contacts_import_count_invalid": "Skipped",
  "mail_contacts_import_undo_hint": "Not right after all? You can undo it below.",
  "mail_contacts_imports_title": "Earlier imports",
  "mail_contacts_imports_no_name": "Import",
  "mail_contacts_imports_counts": "{added} new, {updated} updated",
  "mail_contacts_imports_undone": "undone: {n} deleted, {kept} kept because they already got mail",
  "mail_contacts_imports_undo": "Undo",
  "mail_contacts_imports_undo_title": "Undo import?",
  "mail_contacts_imports_undo_confirm": "Contacts that were new in this import are deleted. Anyone who already got a mail from you stays. People who were already on your list keep everything, including tags and consent the import added.",
  "mail_contacts_imports_undo_failed": "Couldn't undo",

  // Newsletter and message to visitors (phase 2b)
  "mail_campaign_error_mail_service_needs_event": "A message to visitors belongs to an activity. Start it on the page of your activity.",
  "mail_campaign_error_mail_template_locked": "This mail is fixed, because it has already been scheduled or sent.",
  "mail_campaign_kind_news": "Newsletter",
  "mail_campaign_kind_service": "Message to visitors",
  "mail_campaign_name_internal": "Name for yourself",
  "mail_campaign_pick_other": "Pick another mail",
  "mail_campaign_from_design": "Or start from a design of your own:",
  "mail_campaign_design_copied": "You get your own copy, the design itself stays as it is.",
  "mail_campaign_pick_keep": "Keep the current one",
  "mail_campaign_replace_title": "Pick another mail?",
  "mail_campaign_replace_confirm": "What you wrote in this mail will be replaced.",
  "mail_campaign_replace": "Replace",
  "mail_campaign_translation_missing": "Not everything is translated yet ({langs}). Anything missing goes out in your first language.",
  "mail_campaign_translation_fix": "Fill in",
  "mail_campaign_postal_label": "Your postal address",
  "mail_campaign_postal_why": "It has to be in every newsletter. You fill it in once.",
  "mail_campaign_postal_save": "Save",
  "mail_campaign_test_colleague": "Test to a colleague",
  "mail_campaign_test_colleague_pick": "Pick a colleague",
  "mail_campaign_test_colleague_send": "Send",
  "mail_campaign_test_not_team": "That address isn't part of your team.",
  "mail_campaign_later": "Send later",
  "mail_campaign_now_instead": "Send now after all",
  "mail_campaign_tz_nl": "Dutch time",
  "mail_campaign_outcome": "How it went",
  "mail_campaign_outcome_cell": "{n} of {total} arrived",
  "mail_campaign_done": "Done, but nobody got your newsletter. | Done: 1 person got your newsletter. | Done: {n} people got your newsletter.",
  "mail_campaign_done_failed": "All addresses worked. | 1 address didn't work. | {n} addresses didn't work.",
  "mail_campaign_blocked_help": "We held these back because the text looked like abuse. Not right? Just mail",
  "mail_campaign_delete": "Delete",
  "mail_campaign_delete_title": "Delete draft?",
  "mail_campaign_delete_message": "‘{name}’ hasn't been sent and is removed completely, including its mail.",
  "mail_campaign_delete_failed": "Deleting didn't work",
  "mail_campaign_copy": "Copy",
  "mail_campaign_copy_name": "Copy of {name}",
  "mail_limit_line": "You have {contacts} people with consent; you mail up to {limit} for free.",
  "mail_limit_close_why": "Want to mail more people? We'll check your list first, so your mails keep landing in the inbox.",
  "mail_limit_reached_why": "Your newsletter can't go out right now. Ask for a higher limit and we'll check your list and raise it.",
  "mail_limit_request": "Ask for a higher limit",
  "mail_limit_requested": "Requested on {date}. We'll let you know.",
  "mail_limit_request_failed": "Requesting didn't work",
  "mail_service_action": "Message visitors",
  "mail_service_default_name": "Message about {event}",
  "mail_service_classic_title": "Switch on the new mails first",
  "mail_service_classic_text": "You send a message to your visitors with the new mails. Switching takes a minute, and nothing changes until you switch something on.",
  "mail_service_classic_action": "See how",
  "mail_service_recipients_upcoming": "Everyone with a ticket for {event}, for the timeslots still to come.",
  "mail_service_recipients_all": "Everyone with a ticket for {event}, also for timeslots that are over.",
  "mail_service_count_nobody": "Nobody has a valid ticket for these timeslots yet.",
  "mail_service_count_tickets": "no tickets | 1 ticket | {n} tickets",
  "mail_service_count_addresses": "no addresses | 1 address | {n} addresses",
  "mail_service_count_bounced": "none | 1 address doesn't work | {n} addresses don't work",
  "mail_service_count_no_email": "none | 1 order without an email address | {n} orders without an email address",
  "mail_service_order_no_name": "Order without a name",
  "mail_service_no_email_more": "and {n} more",
  "mail_service_pick_slots": "Pick timeslots",
  "mail_service_slots": "Which timeslots?",
  "mail_service_slots_all_upcoming": "All timeslots still to come",
  "mail_service_slots_all": "All timeslots",
  "mail_service_slots_include_past": "Also timeslots that are over",
  "mail_service_summary_line": "Nobody gets ‘{subject}’. | 1 visitor gets ‘{subject}’. | {n} visitors get ‘{subject}’.",
  "mail_service_summary_no_recipients": "There's nobody with a ticket yet who can get this message.",
  "mail_service_no_send_right": "You can prepare this message, but only someone with the right to send mails can send it.",
  "mail_service_reassure": "No consent needed: this is about their ticket. Keep it to the change.",
  "mail_service_test_intro": "Want to see how it arrives? Send it to yourself first.",
  "mail_service_confirm_now": "Nobody gets this message. | 1 visitor gets this message right away. You can't take it back after that. | {n} visitors get this message right away. You can't take it back after that.",
  "mail_service_confirm_later": "Nobody gets this message. | 1 visitor gets this message on {when}. Until then you can cancel. | {n} visitors get this message on {when}. Until then you can cancel.",
  "mail_service_cancel": "Cancel message",
  "mail_service_cancel_help": "Possible as long as nothing has been sent. The message becomes a draft again.",
  "mail_service_cancel_title": "Cancel message?",
  "mail_service_cancel_confirm": "Nothing goes out and the message becomes a draft again, so you can change it.",
  "mail_service_done": "Sent to nobody. | Sent to 1 visitor of {target}. | Sent to {n} visitors of {target}.",
  "mail_service_done_replies": "Replies come in at",
  "mail_segment_preset_new_this_year": "New this year",
  "mail_segment_preset_not_seen_year": "Not seen for a year",
  "mail_campaign_kind_invitation": "Invitation",
  "mail_invitation_default_name": "Invitation {discount}",
  "mail_invitation_codes_of": "With codes of {discount}",
  "mail_invitation_who": "Who are you inviting?",
  "mail_invitation_mode_consent": "With consent",
  "mail_invitation_mode_group": "A group",
  "mail_invitation_mode_list": "Own list",
  "mail_invitation_consent_line": "Everyone who agreed to be mailed.",
  "mail_invitation_reminder_recipients": "Who got the invitation and has not bought yet. They get the same code once more.",
  "mail_invitation_list_label": "Paste your list, one person per line",
  "mail_invitation_list_placeholder": "Jane Doe <jane{'@'}example.com>\nsam{'@'}example.com",
  "mail_invitation_list_save": "Save list",
  "mail_invitation_list_csv": "Choose CSV",
  "mail_invitation_list_saved": "Nobody on your list | 1 person on your list | {n} people on your list",
  "mail_invitation_list_new": "{n} new in your contacts",
  "mail_invitation_list_unreachable": "none | 1 gets nothing: unsubscribed or address not working | {n} get nothing: unsubscribed or address not working",
  "mail_invitation_list_invalid": "None | This address is not right and is left out: {list} | These addresses are not right and are left out: {list}",
  "mail_invitation_list_confirm": "These people expect this from you (members, sponsors, guests)",
  "mail_invitation_unsubscribe_line": "Every mail has an unsubscribe link. Whoever unsubscribed never gets it.",
  "mail_invitation_summary_line": "Nobody gets a code. | 1 person gets ‘{subject}’ with their own code. | {n} people get ‘{subject}’, each with their own code.",
  "mail_invitation_summary_no_recipients": "Nobody can get this invitation yet. Pick who you invite under Recipients.",
  "mail_invitation_no_send_right": "You can prepare this invitation, but only someone allowed to send mails can send it.",
  "mail_invitation_cancel": "Cancel invitation",
  "mail_invitation_cancel_help": "Possible as long as nothing went out. The invitation becomes a draft again.",
  "mail_invitation_cancel_title": "Cancel invitation?",
  "mail_invitation_cancel_confirm": "Nothing goes out and the invitation becomes a draft again, so you can change it.",
  "mail_invitation_done": "Done, but nobody got your invitation. | Done: 1 person got your invitation. | Done: {n} people got your invitation.",
  "mail_invitation_held": "Being checked",
  "mail_invitation_held_line": "We take a quick look before your own list is mailed. After that the mails go out by themselves.",
  "mail_invitation_report_title": "Who is coming",
  "mail_invitation_report_counts": "{mailed} mailed · {bought} bought",
  "mail_invitation_bought": "Bought",
  "mail_invitation_export_unused": "Export unused codes",
  "mail_invitation_remind": "Send reminder",
  "mail_invitation_remind_help": "Nobody | To 1 person who has not bought yet, with the same code. | To {n} people who have not bought yet, with the same code.",
  "mail_invitation_remind_nobody": "Everyone who got it has bought already.",
  "mail_invitation_remind_failed": "Could not make the reminder",
  "mail_campaign_error_mail_invitation_needs_discount": "The discount of this invitation is off or gone. Switch it on under Discounts.",
  "mail_campaign_error_mail_invitation_needs_confirmation": "Tick under Recipients that these people expect this from you.",
  "mail_campaign_error_mail_campaign_not_found": "This message no longer exists. Refresh the page.",
  "mail_campaign_error_mail_campaign_not_invitation": "This only works for an invitation.",
  "mail_campaign_error_mail_list_invalid": "We could not read that list. Put one address per line and try again.",
  "mail_campaign_error_mail_campaign_not_sent": "A reminder can only go once the invitation has been sent.",
  "mail_campaign_rail_content": "What do you want to say",
  "mail_campaign_rail_recipients": "Who gets it",
  "mail_campaign_rail_send": "Send",
  "mail_campaign_steps": "Steps",
  "mail_campaign_step_done": "Done",
  "mail_campaign_next": "Next: {step}",
  "mail_campaign_to_send": "On to sending",
  "mail_campaign_content_title": "What do you want to say?",
  "mail_campaign_content_line": "Your mail is ready in the style of your shop. Change it or send it as it is.",
  "mail_campaign_recipients_title": "Who gets it?",
  "mail_campaign_when_now": "as soon as you send",
  "mail_campaign_when_at": "on {when}",
  "mail_campaign_postal_missing_title": "Your postal address is missing.",
  "mail_campaign_postal_fill": "Fill in address",
  "mail_campaign_postal_address": "Address",
  "mail_campaign_postal_hint": "Shown small at the bottom of every newsletter.",
  "mail_campaign_test_step": "1. A test mail first",
  "mail_campaign_test_why": "So you see how it arrives.",
  "mail_campaign_test_also_colleague": "Also to a colleague",
  "mail_campaign_when_step": "2. When?",
  "mail_campaign_send": "Send",
  "mail_campaign_block_recipients": "Pick who gets it first.",
  "mail_campaign_block_postal": "Fill in your postal address first.",
  "mail_campaign_block_limit": "You are over your contact limit. Ask for a higher limit above.",
  "mail_campaign_block_when": "Pick a moment that is still to come.",
  "mail_campaign_confirm_news_now_title": "Send the newsletter to nobody? | Send the newsletter to 1 person? | Send the newsletter to {n} people?",
  "mail_campaign_confirm_news_now": "Cannot be undone: once it is out, you cannot call it back or change it.",
  "mail_campaign_confirm_news_later_title": "Schedule the newsletter for {when}?",
  "mail_campaign_confirm_news_later": "Until then you can still stop it.",
  "mail_campaign_scheduled_line": "Goes out on {when} ({tz}). | Goes to 1 person on {when} ({tz}). | Goes to {n} people on {when} ({tz}).",
  "mail_campaign_tile_sent": "sent",
  "mail_campaign_tile_arrived": "arrived",
  "mail_campaign_unschedule": "Stop schedule",
  "mail_campaign_unscheduled": "Schedule stopped, it is a draft again",
  "mail_campaign_copy_next": "Copy this for the next one",
  "mail_segment_group_label": "Who gets it",
  "mail_segment_group_everyone": "Everyone with consent",
  "mail_segment_group_regulars": "Regulars",
  "mail_segment_group_new_this_year": "New this year",
  "mail_segment_group_not_seen_year": "Not seen for a year",
  "mail_segment_group_lapsed": "Last year, not yet this year",
  "mail_segment_group_no_shows": "Bought, did not come",
  "mail_segment_lapsed_came_pick": "Pick last year's",
  "mail_segment_lapsed_not_pick": "Pick this year's",
  "mail_segment_count_people": "people with consent | person with consent | people with consent",
  "mail_segment_count_of_group": "of the {n} in this group",
  "mail_segment_narrow_label": "Narrow down:",
  "mail_segment_filter_event": "Came to …",
  "mail_segment_filter_period": "Last visit",
  "mail_segment_filter_tag": "Tag",
  "mail_segment_filter_clear": "Remove",
  "mail_segment_filter_remove": "Remove {name}",
  "mail_campaign_summary_people": "nobody | 1 person | {n} people",
  "mail_campaign_summary_get": "gets | gets | get",
  "mail_campaign_summary_no_mail_step": "Pick a mail first under What do you want to say.",
  "mail_invitation_list_unsaved": "Save the list first.",
}
